import React from 'react'
import tw from 'tailwind-styled-components'
import {Lang} from 'yougile-lang'
import {DangerIcon} from '@components/common/icons/icons'
import {TwItemTitleSupport, TwTitle2} from './tw'

const TwContent = tw.div`
  w-[295px]
  h-[132px]
  flex
  flex-col
  items-center
  gap-0
  px-16
  py-12
  rounded-12
  bg-[#F5F5F7]
`

export const ItemExpired = () => {
  return (
    <TwContent className="flex flex-col mt-20">
      <DangerIcon />
      <TwTitle2 className="mt-4">{Lang.msg.noLicense.licenseExpired}</TwTitle2>

      <TwItemTitleSupport className="!text-primary mt-4 tracking-[-0.2px]">
        {Lang.msg.noLicense.contactAdministrator}
      </TwItemTitleSupport>
    </TwContent>
  )
}
